import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@certa/catalyst/components/Dropdown";
import { ChevronDown } from "@certa/icons/components/ChevronDown";
import { Fragment } from "react";
import { useNavigate } from "react-router";
import type {
  BreadcrumbSiblingsDropdownProps,
  BreadcrumbLink
} from "../Breadcrumb.types";
import { BreadcrumbGoToDropdownStyles as styles } from "../BreadcrumbGoToDropdown/BreadcrumbGoToDropdown.styles.ts";
import {
  Ellipsis,
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { CatalystColors } from "@certa/catalyst/constants/styles";
import { Stack } from "@certa/catalyst/layouts/Stack";

const BreadcrumbSiblingsDropdown = ({
  currentLink,
  siblingLinks,
  onLinkClick,
  menuWidth
}: BreadcrumbSiblingsDropdownProps) => {
  const navigate = useNavigate();

  const onRedirect = (link: BreadcrumbLink) => {
    if (link.url) {
      navigate(link.url);
    }
    if (link.onClick) {
      link.onClick();
    }
    onLinkClick?.();
  };

  return (
    <li className={styles.container}>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <button
            className={styles.triggerButton}
            aria-label={`${currentLink.label} - View sibling pages`}
          >
            {!!currentLink.leftIcon &&
              currentLink.leftIcon({
                color: CatalystColors.NEUTRAL_700,
                size: 16,
                className: styles.leftIcon
              })}
            <Typography
              color={TypographyColors.NEUTRAL_800}
              variant={TypographyVariants.LABEL_SM_BOLD}
              as="span"
              className="overflow-hidden"
            >
              <Ellipsis>{currentLink.label}</Ellipsis>
            </Typography>
            <ChevronDown
              className={styles.chevronDown}
              color={CatalystColors.NEUTRAL_700}
              size={12}
            />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent width={menuWidth}>
          <Fragment>
            {/* Current page (non-clickable) */}
            <DropdownMenuCheckboxItem
              value={currentLink.label}
              onChange={() => {}}
              checked={true}
              disabled
            >
              <Stack direction="horizontal" gap="8">
                {currentLink.leftIcon &&
                  currentLink.leftIcon({
                    color: CatalystColors.NEUTRAL_700,
                    size: 16
                  })}
                {currentLink.label}
              </Stack>
            </DropdownMenuCheckboxItem>
            {/* Sibling links */}
            {siblingLinks.map((link, index) => (
              <DropdownMenuItem
                key={index}
                onSelect={() => onRedirect(link)}
                value={link.label}
              >
                {link.leftIcon &&
                  link.leftIcon({
                    color: CatalystColors.NEUTRAL_700,
                    size: 16,
                    className: styles.leftIcon
                  })}
                {link.label}
              </DropdownMenuItem>
            ))}
          </Fragment>
        </DropdownMenuContent>
      </DropdownMenu>
    </li>
  );
};

export { BreadcrumbSiblingsDropdown };
